<template>
  <v-container class="py-6" style="max-width:960px">
    <div class="d-flex align-center mb-2"><v-icon color="primary" class="me-2">mdi-file-document-multiple-outline</v-icon><h2 class="title font-weight-bold">تقاريري</h2><v-spacer/><v-btn icon aria-label="تحديث التقارير" :loading="loading" @click="refreshList"><v-icon>mdi-refresh</v-icon></v-btn></div>
    <p class="body-2 grey--text text--darken-1">تقاريرك المحفوظة في مكان واحد. كل تقرير مبني على نتيجتك وقت إعداده.</p>
    <v-skeleton-loader v-if="loading && !loaded" type="article, article" />
    <v-alert v-if="error" text type="warning">{{error}}<v-btn text small @click="refreshList">حاول تاني</v-btn></v-alert>
    <v-sheet v-if="loaded && !items.length && !error" outlined rounded class="pa-8 text-center">
      <v-icon size="48" color="primary">mdi-file-document-outline</v-icon><h3 class="subtitle-1 mt-3">تقاريرك هتظهر هنا</h3>
      <p class="body-2 mt-2">افتح نتيجة امتحان متاح فيه التقرير الشخصي واطلب تقريرك.</p>
      <v-btn color="primary" depressed :to="{name:'my-exams'}">نتائج امتحاناتي</v-btn>
    </v-sheet>
    <v-card v-for="item in items" :key="item.id" outlined class="mb-4 pa-4">
      <div class="font-weight-bold">{{item.exam_name}}</div><div class="caption grey--text mt-1">{{formatDate(item.completed_at || item.requested_at)}} · {{item.status === 'ready' ? 'محفوظ' : item.status === 'failed' ? 'تعذّر الإعداد' : 'قيد الإعداد'}}</div>
      <exam-personal-report :session-token="item.session_token" :initial-state="item" history @change="refreshList" @review="review(item, $event)" />
      <v-btn text small color="primary" class="mt-2" @click="review(item)">عرض نتيجة الامتحان<v-icon small right>mdi-chevron-left</v-icon></v-btn>
    </v-card>
    <v-pagination v-if="pages > 1" v-model="page" :length="pages" :total-visible="5" class="mt-4" />
  </v-container>
</template>
<script>
import ExamPersonalReport from '@/components/custom/exam-personal-report.vue'
import {createVisiblePoller} from '@/helpers/visible-poller'
export default {
  components:{ExamPersonalReport},
  data:()=>({items:[],page:1,pages:1,loading:false,loaded:false,error:'',poller:null,disposed:false,version:0}),
  watch:{page(){this.version++;this.refreshList()}},
  mounted(){this.poller=createVisiblePoller(this.fetchList);this.refreshList()},
  beforeDestroy(){this.disposed=true;this.version++;this.poller.stop()},
  methods:{
    refreshList(){this.poller.start()},
    async fetchList(){
      const version=this.version;this.loading=true;
      try{const {data}=await window.axios.get('/exams/reports',{params:{page:this.page}});if(this.disposed||version!==this.version)return true;this.items=data.data;this.pages=data.last_page;this.loaded=true;this.error='';return this.items.some(i=>['pending','running'].includes(i.status))}
      catch(e){if(this.disposed || version!==this.version)return false;const terminal=e.response && [401,403,404].includes(e.response.status);this.error=terminal?'التقارير غير متاحة حاليًا. ارجع لنتائج امتحاناتك.':'تعذّر تحميل التقارير. هنحاول تاني لما الاتصال يرجع.';return !terminal}
      finally{if(!this.disposed)this.loading=false}
    },
    formatDate(value){return new Date(value).toLocaleString('ar-EG',{dateStyle:'medium',timeStyle:'short'})},
    review(item,questionId){this.$router.push({name:'exam-session',params:{sessionToken:item.session_token,reportQuestionId:questionId,fromReport:true}})},
  },
}
</script>
